import { Injectable } from '@angular/core';
import { ClientFilter } from '@shared/entities/clientFilter';
import { ApiService } from '@shared/services/api/api.service';
import {
  BehaviorSubject,
  Observable,
  Subject,
  shareReplay,
  switchMap,
  take,
  tap,
} from 'rxjs';

const LOG_PREFIX = '[Api][ClientFilters] ';

@Injectable({
  providedIn: 'root',
})
export class ClientFiltersService extends ApiService<ClientFilter> {
  private refresh$: Subject<boolean>;
  all$: Observable<ClientFilter>;

  constructor() {
    const masterUrl = '/clients/filters';
    const detailUrl = '/clients/filters';

    super(ClientFilter, masterUrl, detailUrl);

    this.refresh$ = new BehaviorSubject<boolean>(true);
    this.all$ = this.refresh$.pipe(
      switchMap(() => {
        return this.findOne('');
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err),
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this.refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}
